<template>
  <div class="item-unit-modal"> 
      <div class="card-body">
        <div class="form-group row">
            <div class="col-md-12">
                <label class="form-label">{{ $t('general.offer_amount_calculation') }}</label>
                <div class="input-field">
                    <span v-html="laonAmount/100"></span>
                    -<span v-html="discount/100"></span>
                    -<span v-html="adminAmount/100"></span>
                </div>
            </div> 
        </div>
      </div>
      <div class="card-footer">
        <base-button
          :outline="true"
          class="mr-3"
          color="theme"
          type="button"
          @click="closeCashFlowValueInvoiceModal"
        >
          {{ $t('general.cancel') }}
        </base-button>
      </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
        isEdit: false,
        isLoading: false,
        discount: 0,
        laonAmount: 0,
        adminAmount:0,
        currency:null
    }    
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData',
      'modalActive'
    ]), 
  },
  created(){
  },
 validations: {},
  async mounted () {
    if (this.modalData) {
      this.setData()
    }
  },
  methods: {
    ...mapActions('modal', [
      'closeModal',
      'resetModalData'
    ]),
    resetFormData () {  
        this.laonAmount= 0,
        this.discount= 0,
        this.adminAmount= 0,
        this.currency=null
    },
    async setData () {
      this.laonAmount= this.modalData.laonAmount,
      this.discount= this.modalData.discount,
      this.adminAmount= this.modalData.adminFee
    },
    closeCashFlowValueInvoiceModal () {
      this.resetFormData()
      this.closeModal()
    },
  }
}
</script>
